import { defineMessages } from 'react-intl-next';

const _default_1: {
    clearAllButtonTooltip: {
        id: string;
        defaultMessage: string;
        description: string;
    };
    selectedText: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
    clearAllButtonTooltip: {
        id: 'atlassian-studio-ui-components.bulk-action-tool-bar.clear-all-button-tooltip',
        defaultMessage: 'Clear all',
        description: 'Tool tip for the button that clears all the selections',
    },
    selectedText: {
        id: 'atlassian-studio-ui-components.bulk-action-tool-bar.selected-text',
        defaultMessage: 'selected',
        description: 'Text that comes after a number to show how many items are selected for bulk edititing',
    },
});
export default _default_1;
